import { t } from '@lingui/core/macro';
import type { ReactNode } from 'react';

import RemoveIcon from '@/assets/svg/bx-x.svg?react';
import { Button, type ButtonProps } from '@/components/buttons';
import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/Tooltip';

type Props = Omit<ButtonProps, 'icon' | 'variant' | 'title'> & {
  title: ReactNode;
  onClick: () => void;
};

const RuleBuilderRemoveButton = ({ title, disabled = false, onClick, ...rest }: Props) => {
  return (
    <Tooltip open={disabled ? false : undefined} disableHoverablePopup>
      <TooltipTrigger
        render={
          <div className="flex h-10 items-center justify-center">
            <Button
              aria-label={t`Remove rule`}
              variant="ghost"
              size="icon-large"
              disabled={disabled}
              onClick={onClick}
              {...rest}
            >
              <RemoveIcon />
            </Button>
          </div>
        }
      />
      <TooltipContent side="top">{title}</TooltipContent>
    </Tooltip>
  );
};

export default RuleBuilderRemoveButton;
